<template>
  <div id="app">
    <div class="wrapper-with-side-menu" v-if="isShowSideMenu">
      <side-menu/>
      <div class="container-with-side-menu">
        <Header v-if="isShowHeader" @mobileMenuToggle="mobileMenuToggle"/>
        <router-view v-if="isAuthChecked" :class="{'mobile-menu-open': isMobileMenuOpen}"/>
      </div>
    </div>
    <div class="wrapper-without-side-menu" v-if="!isShowSideMenu">
      <Header v-if="isShowHeader"/>
        <router-view v-if="isAuthChecked"/>
    </div>
    <Footer v-if="isShowFooter"/>
    <cookie-banner/>
    <base-spinner
      :is-loading="isLoading"
    />
    <base-error-modal
      v-if="errorMessage"
      :error-message="errorMessage"
    />
  </div>
</template>

<script>
import HttpService from './services/index';
import { mapGetters } from 'vuex';
import BaseSpinner from './components/base/BaseSpinner.vue';
import BaseErrorModal from './components/base/BaseErrorModal.vue';
import Header from './components/common/Header.vue';
import Footer from './components/common/Footer.vue';
import SideMenu from './components/common/SideMenu.vue';
import CookieBanner from './components/common/CookieBanner.vue';

export default {
  name: 'App',
  provide: {
    $httpService: new HttpService()
  },
  components: {
    BaseSpinner,
    BaseErrorModal,
    Header,
    Footer,
    SideMenu,
    CookieBanner
  },
  data() {
    return {
      isMobileMenuOpen: false,
      isAuthChecked: false
    }
  },
  computed: {
    ...mapGetters(['isLoading', 'errorMessage']),
    isShowHeader() {
      return this.$route.name !== 'SignIn' && this.$route.name !== 'auth-password-change' && this.$route.name !== 'NotFound' && 
        this.$route.name !== 'PasswordRecovery' && this.$route.name !== 'msi' &&
        this.$route.name !== 'SignUp' && this.$route.name !== 'main' && this.$route.name !== 'contract' && this.$route.name !== 'scoringAgreement'  &&
        this.$route.name !== 'contacts' && this.$route.name !== 'legislation' && this.$route.name !== 'getLoan' &&
        this.$route.name !== 'investing' && this.$route.name !== 'questions' && this.$route.name !== 'about' && 
        this.$route.name !== 'arbitration' && this.$route.name !== 'documents' && this.$route.name !== 'documentsActive' && this.$route.name !== 'documentsArchive' && this.$route.name !== 'documentsPending' && this.$route.name !== 'news';
    },
    isShowFooter() {
      return this.$route.name !== 'SignIn' && this.$route.name !== 'auth-password-change' && this.$route.name !== 'NotFound' && 
        this.$route.name !== 'PasswordRecovery' && this.$route.name !== 'msi' &&
        this.$route.name !== 'SignUp' && this.$route.name !== 'contract' && this.$route.name !== 'scoringAgreement' ;
    },
    isShowSideMenu() {
      return this.$route.name !== 'SignIn' && this.$route.name !== 'auth-password-change' && this.$route.name !== 'NotFound' && 
        this.$route.name !== 'PasswordRecovery' && this.$route.name !== 'msi' &&
        this.$route.name !== 'SignUp' && this.$route.name !== 'main' && this.$route.name !== 'contract' && this.$route.name !== 'scoringAgreement'  &&
        this.$route.name !== 'contacts' && this.$route.name !== 'legislation' && this.$route.name !== 'getLoan' &&
        this.$route.name !== 'investing' && this.$route.name !== 'questions' && this.$route.name !== 'about' && 
        this.$route.name !== 'arbitration' && this.$route.name !== 'documents' && this.$route.name !== 'documentsActive' && this.$route.name !== 'documentsArchive' && this.$route.name !== 'documentsPending' && this.$route.name !== 'news';
    }
  },
  async created() {
    this.setLocale();
    await this.$store.dispatch('checkAuth');
    this.isAuthChecked = true;
  },
  methods: {
    setLocale() {
      const locale = localStorage.getItem('locale');

      if (locale) {
        this.$i18n.locale = locale;
      } else {
        const defaultLanguage = window.entityCabinetSettings.defaultLanguage;
        localStorage.setItem('locale', defaultLanguage);
        this.$i18n.locale = defaultLanguage;
      }
    },
    mobileMenuToggle(value) {
      this.isMobileMenuOpen = value;
    }
  }
}
</script>

<style lang="scss">
  @import '../src/assets/style.scss';
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@100;200;300;400;500;600;700;800;900&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500;600;700;800&display=swap');

  @font-face {
    font-family: 'Bullet';
    src: url('./assets/fonts/Bullet/bullet.otf');
  }

  #app {
    width: 100%;
    min-height: 100vh;
    height: 100vh;
    max-height: max-content;
  }

  * {
    font-family: 'Open Sans', sans-serif;
  }

  #app {
    .mx-input, 
    .mx-datepicker,
    .mx-input-wrapper {
      height: 100%;
      width: 100%;
      border-radius: var(--base-input-border-radius);
    }

    .mx-input:hover:focus {
      border-color: var(--datepicker-hover-color);
    }

    .mx-input {
      font-weight: 400;
      font-size: 16px;
      line-height: 135%;
    }

    .mx-input:hover {
      border-color: var(--datepicker-hover-color);
    }

    .mx-input:focus {
      border-color: var(--datepicker-hover-color);
    }

    input:disabled{
      background-color: var(--base-input-disabled-bgc);
      color: var(--base-input-disabled-color);
    }

    .mx-input:-webkit-autofill,
    .mx-input:-webkit-autofill:hover,
    .mx-input:-webkit-autofill:focus,
    .mx-input:-webkit-autofill:active {
      -webkit-box-shadow: 0 0 0 1000px #ffffff inset;
      box-shadow: 0 0 0 1000px #ffffff inset;
      -webkit-text-fill-color: inherit;
      caret-color: inherit;
      transition: background-color 5000s ease-in-out 0s;
    }
  }

  body {
    .mx-calendar+.mx-calendar {
      display: none;
    }

    .mx-datepicker-popup {
      width: 348px;
      margin-left: 2px;
      box-sizing: border-box;
      box-shadow: 2px 2px 19px rgba(191, 191, 191, 0.45);
      border-radius: 20px;
    }

    .mx-calendar {
      width: 100%;
      padding: 36px 30px;
      box-sizing: border-box;
      font-weight: 400;
      font-size: 16px;
      line-height: 135%;
      font-family: 'Open Sans';
    }

    .mx-calendar-header {
      padding: 0 5px;
      margin-bottom: 15px;
      box-sizing: border-box;
    }

    .mx-btn:not(.mx-btn-current-month):not(.mx-btn-current-year) {
      color: var(--datepicker-btns-color);
    }

    .mx-btn-icon-right,
    .mx-btn-icon-left,
    .mx-btn-icon-double-right,
    .mx-btn-icon-double-left {
      transform: scale(1.5);
    }

    .mx-btn-text {
      padding: 0 8px;
      box-sizing: border-box;
    }

    .mx-btn-current-month,
    .mx-btn-current-year {
      text-transform: capitalize;
      font-weight: 600;
      font-size: 17px;
      color: var(--datepicker-header-color);
    }

    .mx-table th {
      font-weight: 600;
      font-size: 16px;
      color: var(--datepicker-header-color);
    }

    .mx-table-date td {
      font-size: 16px;
      color: var(--datepicker-header-color);
    }

    .cell.today {
      color: var(--datepicker-btns-color);
      font-weight: 700;
    }

    .mx-calendar-content .cell.active {
      background-color: var(--datepicker-selected-date-bgc);
      color: var(--datepicker-selected-date-color);
    }
  }

  .wrapper-without-side-menu {
    min-height: 100%;
  }

  .wrapper-without-side-menu,
  .wrapper-with-side-menu {
    width: 100%;
  }

  .wrapper-with-side-menu {
    display: flex;
    justify-content: flex-end;
    position: relative;
    min-height: 500px;
    // min-width: 1300px;
  }

  .container-with-side-menu {
    width: calc(100% - 327px);
  }

  .mobile-menu-open {
    margin-top: 74px;
  }

  @media screen and (max-width: 1450px) {
    .container-with-side-menu {
      width: calc(100% - 270px);
    }
  }

  @media screen and (max-width: 1390px) {
    .container-with-side-menu {
      width: calc(100% - 240px);
    }
  }

  @media screen and (max-width: 1155px) {
    .container-with-side-menu {
      width: 100%;
    }
  }
</style>
